import { Link } from "react-router-dom";

const quickLinks = [
  { label: "社区新闻", to: "/news" },
  { label: "邻里论坛", to: "/forum" },
  { label: "生活服务", to: "/services" },
  { label: "发布信息", to: "/post" },
  { label: "关于邻居", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

const friendLinks = ["街道社区服务中心", "城市便民热线", "社区志愿服务队", "本地生活指南"];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100 mt-16">
      <div className="w-full px-4 md:px-6 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-lg bg-background-50 text-primary-700 flex items-center justify-center">
              <i className="ri-home-heart-fill text-lg"></i>
            </span>
            <span className="text-xl font-bold text-background-50">邻居</span>
          </div>
          <p className="text-sm text-background-100/80 leading-relaxed max-w-md">
            邻居是本地社区交流平台，致力于打造和谐邻里关系。在这里了解身边新闻、参与邻里互动、查找生活服务，让社区更有温度。
          </p>
          <div className="flex items-center gap-3 mt-5 text-background-100/80 text-sm">
            <span className="flex items-center gap-1.5"><i className="ri-map-pin-line"></i> 槐树街道社区服务中心</span>
            <span className="flex items-center gap-1.5"><i className="ri-phone-line"></i> 0000-1234567</span>
          </div>
        </div>

        <div>
          <h4 className="text-background-50 font-semibold mb-4 text-sm">快速导航</h4>
          <ul className="space-y-2.5">
            {quickLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-background-100/80 hover:text-background-50 transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-background-50 font-semibold mb-4 text-sm">友情链接</h4>
          <ul className="space-y-2.5">
            {friendLinks.map((l) => (
              <li key={l}>
                <a href="/about" className="text-sm text-background-100/80 hover:text-background-50 transition-colors">
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/15">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-100/70">
          <p>© 2026 邻居 · 本地社区交流平台 版权所有</p>
          <div className="flex items-center gap-5">
            <a href="/about" className="hover:text-background-50 transition-colors">隐私政策</a>
            <a href="/about" className="hover:text-background-50 transition-colors">服务条款</a>
            <a href="/contact" className="hover:text-background-50 transition-colors">意见反馈</a>
          </div>
        </div>
      </div>
    </footer>
  );
}